export const testimonyData = [
  {
    id: 1,
    name: "Firman Zain Firdauz",
    role: "Back End Developer",
    company: "Paydia",
    quote:
      "Pekerjaan bagus, deadline terbantu, task terselesaikan. Frontend developer mantap 👍🏻",
    linkedin: "https://www.linkedin.com/in/firmanzain/",
    path_url:
      "https://drive.google.com/uc?id=1GK3PrJ-BvKsggJ6PeKmebor5AbyJ9c4e&export=download",
  },
  {
    id: 2,
    name: "Anak Agung Angga Wijaya",
    role: "Back End Developer | Cloud Engineer",
    company: "KERJOO",
    quote:
      "Orang yang rajin , jujur, dan tepat waktu dalam pengerjaan proyek. memiliki skill problem solving yang bagus dan dapat mengikuti perkembangan trend",
    linkedin: "https://www.linkedin.com/in/anak-agung-angga-wijaya-333684170/",
    path_url:
      "https://drive.google.com/uc?id=1_90IcCZA_y7OFdxH2VK3-GfI2UEeocBq&export=download",
  },
  {
    id: 3,
    name: "Dio Putra Utama",
    role: "iOS Engineer",
    company: "Privy",
    quote: "semangat kerja yang tinggi",
    linkedin: "https://www.linkedin.com/in/dio-putra-utama-1a46b0179/",
    path_url:
      "https://drive.google.com/uc?id=1_dvmcVgknYMRGQaYRrVzVUYUECBJSYcQ&export=download",
  },
  {
    id: 4,
    name: "Rakhmat Fadhillah",
    role: "Senior UI Designer",
    company: "PT. Nusantara Sukses Teknologi (Nusatek)",
    quote:
      "Mengerjakan beberapa fitur sistem manajemen sekolah dengan Iqbal menjadi lebih enjoy karena Iqbal mampu advice secara detail tentang technical constraint yang berkaitan dengan Frontend. Iqbal berpikiran terbuka dengan mendengarkan reason atas desain yang saya buat dan juga teliti perduli dengan beberapa hal yang terlewat dari apa yang saya desain. Tidak hanya paham tentang frontend, Iqbal juga paham tentang saham, emas, reksadana sehingga diskusi pekerjaan bisa lebih seru dengan sedikit campuran diskusi tentang itu semua. Goodluck untukmu Iqbal !",
    linkedin: "https://www.linkedin.com/in/rakhmat-fadhillah-211851130/",
    path_url:
      "https://drive.google.com/uc?id=19vnI63RUDmANry1PbeUVH0uoJjmGgyaJ&export=download",
  },
  {
    id: 5,
    name: "M Hasan",
    role: "Development Manager",
    company: "GoCement",
    quote:
      "He always have a Creative Thinking, He always create UI like the Design, He can works with short deadline,  He is a Fast Learner, He always responsible with his jobs, His friends always feels helped by his works",
    linkedin: "https://www.linkedin.com/in/--emha/",
    path_url:
      "https://drive.google.com/uc?id=1D9BToFlZ5LkKYZe_vFLINCPyDUQq3jk9&export=download",
  },
  {
    id: 6,
    name: "Muhammad Reza Pahlawan",
    role: "Software QA",
    company: "GoCement",
    quote:
      "I had the privilege of working alongside Iqbal during his time at GoCement as a Junior Front-end Developer. His technical skills and attention to detail in his work truly set him apart. Whether it was developing new user-facing features or fixing complex bugs, Iqbal consistently delivered high-quality results. Iqbal is a quick learner and is not afraid to take on challenging projects. He always approached his work with a positive attitude and was a valuable asset to our team. His excellent communication skills and ability to work well with others made him a pleasure to collaborate with. I highly recommend Iqbal for any front-end development role. He has the skills, drive, and commitment to succeed, and I am confident that he will make a valuable contribution to any organization. Keep up the good work, Iqbal!",
    linkedin: "https://www.linkedin.com/in/muhammad-reza-pahlawan/",
    path_url:
      "https://drive.google.com/uc?id=1xJNtdhD5EUiu8gYEyvePx2DqYM5lQyiy&export=download",
  },
  {
    id: 7,
    name: "Muhammad Rifai Idris",
    role: "Lead Frontend Web Developer",
    company: "GoCement",
    quote: "partner kerja frontend yang bisa diandalkan",
    linkedin: "https://www.linkedin.com/in/muhammad-rifai-idris/",
    path_url:
      "https://drive.google.com/uc?id=1Vzz2B7u9IYYhQ9wwMqDp76Uu2v_2v65P&export=download",
  },
  {
    id: 8,
    name: "Lintang Sekarmayang",
    role: "IT Business Analyst",
    company: "PT. Pegadaian",
    quote:
      "I was impressed by Iqbal’s ability to handle any situation patiently. This natural skill of his has helped us grab many tasks throughout our work’s journey.",
    linkedin: "https://www.linkedin.com/in/muhammad-rifai-idris/",
    path_url:
      "https://drive.google.com/uc?id=1Vzz2B7u9IYYhQ9wwMqDp76Uu2v_2v65P&export=download",
  },
];
